import EmptyState from "Components/organisms/empty-state"
import { OpportunityDashboardView, OpportunityDashboardViews } from "models/opportunity-dashboard"
import FunnelRevenueTab from "./funnel-revenue-tab"
import OpportunitiesTab from "./opportunities-tab"
import OutcomeReportTab from "./outcome-report-tab"

interface OpportunityDashboardContentProps {
    view: OpportunityDashboardView
    views: OpportunityDashboardViews
}

// Body of the active tab.
const OpportunityDashboardContent = ({ view, views }: OpportunityDashboardContentProps) => {
    switch (view) {
        case "funnel":
            return views.funnel ? <FunnelRevenueTab data={views.funnel} /> : <EmptyState />
        case "opportunities":
            return views.opportunities ? <OpportunitiesTab data={views.opportunities} /> : <EmptyState />
        default: {
            const data = views[view]
            return data ? <OutcomeReportTab key={view} type={view} data={data} /> : <EmptyState />
        }
    }
}

export default OpportunityDashboardContent
